import { useEffect } from 'react'
import { Provider } from 'react-redux'
import { loadFontIcons } from 'components/FontIcon'
import store from 'utils/store'
import Router from './routes'
import useForceReload from 'utils/useForceReload'
import styles from "./index.module.scss"

function App() {
  // Auto-reload stale tabs when a new version is deployed (see utils/useForceReload).
  useForceReload()

  useEffect(() => {
    loadFontIcons()
  }, [])

  return (
    <Provider store={store}>
      <div className={styles.main}>
        <div className={styles.appRoot}>
          <Router />
        </div>
      </div>

    </Provider>
  )
}

export default App
